export default __webpack_public_path__ + "74f85483ba810e14982ab8edd4067db1.svg";